export const fmtCAD = (n) => {
  const v = Number(n || 0);
  return v.toLocaleString("en-CA", { style: "currency", currency: "CAD" });
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  } catch {
    return iso;
  }
};

// Screenshot-style "06/18/26 · Thu 2:22 PM" — used on customer detail tables
export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yy = String(d.getFullYear()).slice(-2);
    const wd = d.toLocaleDateString("en-CA", { weekday: "short" });
    const t = d.toLocaleTimeString("en-CA", { hour: "numeric", minute: "2-digit" });
    return `${dd}/${mm}/${yy} · ${wd} ${t}`;
  } catch {
    return iso;
  }
};

export const todayIso = () => new Date().toISOString().split("T")[0];

export const statusClass = (s) => {
  const k = (s || "").toLowerCase().replace(/ /g, "-");
  return `badge-${k}`;
};
